import { ref } from 'vue'

import { createSharedComposable } from '@shared/utils/helpers/create-composable'

import { useMessagesStore } from '@pc/store/messages'

export const useAiRefreshedMessageScroll = createSharedComposable(() => {
  const messagesStore = useMessagesStore()

  const refreshedQuestionMessageId = ref()

  const needToAddPadding = ref(false)

  const scrollToReferencedMessage = (aiMessageId: number) => {
    refreshedQuestionMessageId.value =
      messagesStore.messages.data?.data.find(
        (message) => message.id === aiMessageId
      )?.replyToChatMessageId ?? 0

    needToAddPadding.value = true

    // 1500 because we have 1s delay in styles for app-space-for-ai block, so we need to wait while this duration would be finished
    setTimeout(scrollToQuestion, 1500)
  }

  const resetRefreshedQuestionMessageId = () => {
    refreshedQuestionMessageId.value = 0
  }

  const scrollToQuestion = () => {
    const question = document.getElementById(refreshedQuestionMessageId.value)

    if (question) {
      question?.scrollIntoView({ behavior: 'smooth' })
    }
  }

  return {
    refreshedQuestionMessageId,
    scrollToReferencedMessage,
    needToAddPadding,
    resetRefreshedQuestionMessageId,
    scrollToQuestion,
  }
})
